import { AssortmentTypesManagementPage } from '@features/Assortments/AssortmentTypes/AssortmentTypesManagementPage'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'

export const Route = createFileRoute('/assortment/types')({
  component: AssortmentTypesManagementPage,
  staticData: {
    breadcrumb: t('assortments.types.pageTitle'),
  },
})
